import { useHistory } from "react-router-dom";
import { ActionIcon, Avatar, Badge, Box, Button, Group, Image, Text, Tooltip, useMantineColorScheme } from '@mantine/core';
import { useMediaQuery } from "@mantine/hooks";
import { IconCircleChevronLeft, IconCircleChevronRight, IconAlertTriangle, IconSearch } from "@tabler/icons-react";

import { useNavigationBarState } from "./NavigationBar";
import ThemeToggle from "../Shared/ThemeToggle";

export const HeaderBar = () => {
	const history = useHistory();
	const isMobile = useMediaQuery('(max-width: 48em)');
	const { colorScheme } = useMantineColorScheme();
	const { isOpen: navigationOpened, toggle: toggleNavigation } = useNavigationBarState();
	const logoPath = colorScheme === "light" ? `/${import.meta.env.VITE_ICON192}` : `/${import.meta.env.VITE_ICON192_WHITE}`;

	return <>
		<Group h="100%" px="md" style={{ boxShadow: 'rgba(0, 0, 0, 0.05) 0px 2px 12px' }} justify='space-between' wrap="nowrap">
			<Group gap="xs">
				{/* <Burger opened={opened} onClick={() => handleNavigationToggled(!opened)} size="sm" /> */}
				{(navigationOpened || isMobile) && <>
					<Tooltip label="Collapse Navigation" color="var(--mantine-primary-color-filled)" withArrow arrowSize={10} position="right" radius="sm">
						<ActionIcon radius="xl" variant="subtle" color="indigo.3" bg="var(--mantine-color-body" ml={navigationOpened && !isMobile ? -30 : 0 } mt={3} onClick={toggleNavigation}>{navigationOpened ? <IconCircleChevronLeft /> : <IconCircleChevronRight /> }</ActionIcon>
					</Tooltip>
				</>
				}

				<Group gap="xs" hiddenFrom={navigationOpened ? "sm" : "" }>
					<Avatar styles={{ placeholder: { border: 'unset' }}}><Image src={logoPath} /></Avatar>
					<Text fw="bold" fz="18px">{import.meta.env.VITE_NAV_TITLE}</Text>
				</Group>

			</Group>

			<Group visibleFrom="sm">
				{!import.meta.env.MODE.includes('production') &&
				<Badge leftSection={<IconAlertTriangle size={14} />}>Test environment</Badge>
				}
				<Button onClick={() => history.push({ pathname: "/search" })} variant="default" bg="var(--mantine-color-gray-light)" size="xs" style={{ border: '0px' }} leftSection={<IconSearch size={16} />} radius="xl">
					<Box><Text fz="sm" ta="left" c="dimmed">Search</Text></Box>
				</Button>
				<ThemeToggle />
			</Group>

		</Group>
	</>
}